const scrollerSelector = ".scroller";

if (document.querySelector(scrollerSelector)) {
  const startScroller = () => {
    Splide.defaults = {
      type: "loop",
      perPage: 1,
    };

    document.querySelectorAll(scrollerSelector).forEach((slider) => {
      new Splide(slider).mount();
    });
  };

  const loadCSS = (href) => {
    const link = document.createElement("link");
    Object.assign(link, {
      href,
      rel: "stylesheet",
    });
    document.head.appendChild(link);
  };

  const loadScript = (src, onLoad) => {
    const script = document.createElement("script");
    Object.assign(script, {
      src,
      defer: true,
    });
    script.addEventListener("load", onLoad);
    document.head.appendChild(script);
  };

  loadCSS("/public/dist/css/scroller-core.min.css");
  loadScript("/public/dist/js/scroller.min.js", startScroller);
}
